import { render, staticRenderFns } from "./presentation-player.vue?vue&type=template&id=01c5e640&"
import script from "./presentation-player.vue?vue&type=script&lang=js&"
export * from "./presentation-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports